export default __webpack_public_path__ + "static/media/mountain_makovitsa_768.f5606890.webp";